<app-main-layout [disableWatchingRoutes]="true">
  <div class="block">
    <div class="ckeckmark-item">
      <img src="assets/icons/checkmark.svg" alt="">
    </div>
    <div class="main-heading">
      <h2 class="center">
        {{ commentsSubmitted ? 'Additional comments are submitted!' : 'Your form is submitted!' }}
      </h2>
      @if (!commentsSubmitted) {
        <div class="center cs-inner-html-16">
          <p>A sales representative will use our satellite imagery to get measurements and email you a quote within 24 hours!</p>
        </div>
      }
    </div>
  </div>
</app-main-layout>